import { useState } from 'react';
import {
  Editor,
  EditorChangeEvent,
  EditorMountEvent,
  EditorProps,
  EditorTools
} from '@progress/kendo-react-editor';
import { createView } from './create-markdown-view';
import { defaultMarkdownParser } from 'prosemirror-markdown';
import { Node as ProsemirrorNode } from 'prosemirror-model';

interface EditorInputProps extends EditorProps {
  handleMarkdownChange?: (event: EditorChangeEvent) => void;
}

export function MarkdownEditor({ ...props }: EditorInputProps) {
  const [value, setValue] = useState<ProsemirrorNode | undefined>(() => {
    const parsed = defaultMarkdownParser.parse(props.value as string);
    return parsed || undefined;
  });

  const { Bold, Italic, FormatBlock, Undo, Redo, OrderedList, UnorderedList } =
    EditorTools;

  const onMount = (event: EditorMountEvent) => createView(event);

  const onChange = (e: EditorChangeEvent) => {
    setValue(e.value);
    if (props.handleMarkdownChange) props.handleMarkdownChange(e);
  };

  return (
    <Editor
      contentStyle={{ height: 500, width: '100%' }}
      onMount={onMount}
      tools={[
        [Bold, Italic],
        [Undo, Redo],
        [OrderedList, UnorderedList],
        FormatBlock
      ]}
      onChange={onChange}
      value={value!}
    />
  );
}
